import { get } from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";

const urlBucket = window.config.Statics.BucketUrl;
let liveFireUrlApi = window.config.Statics.ApiLiveFireUrl;
const siteIdLF = window.config.Statics.SiteIdLF;
const urlAcuTema = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoTemaUrl;
const sitioId = window.config.Sitio.Id;

const getMasComentadas = (data) => {
    let masComentadas = document.querySelector('aside[data-id="masComentadas"]');
    if (masComentadas !== null) {
        if(data !== null && data.data !== null && data.data.length > 0){
            let html = `<div class="techo floatFix">
                        <h4>Más <b>comentadas</b></h4>
                    </div>
                    <ol>`;
            for (let nota of data.data.slice(0,5)) {
                let parts = nota.url.split('/');
                let url = parts.pop();
            //<img src="http://bucket1.glanacion.com/anexos/fotos/16/tecnologia-2086816w122h82.jpg " />
                html += `<li>
                    <article title="" class="nota floatFix">
                        <a class="figure">                        
                        </a>
                        <h2>
                            <a href="/${url}">${nota.title}</a>
                        </h2>
                    </article>
                    </li>`;
            }  

            html += `</ol>`;
            masComentadas.innerHTML = html;
        }
    }
}

export const notasMasComentadas = () => {
    let masComentadas = document.querySelector('aside[data-id="masComentadas"]');
    if (masComentadas !== null && masComentadas.length > 0) {
        liveFireUrlApi = liveFireUrlApi.replace("{livefyre-domainName}", "la-nacion");
        liveFireUrlApi = liveFireUrlApi.replace("{SiteId_Livefyre}", siteIdLF);
        liveFireUrlApi = liveFireUrlApi.replace("{cantidad de notas}", 10);

        get(liveFireUrlApi)
            .then(rs => JSON.parse(rs))
            .then(getMasComentadas);
    }
}


const renderNotasAdemas = (data) => {
    let nodoAdemas = document.querySelector('#listadoAdemas');
    if (data.items !== null && data.items.length > 1 && nodoAdemas !== null && nodoAdemas !== undefined) {

        const notaId = document.querySelector('div[data-notaid]').getAttribute("data-notaid");
        data.items.filter(function(item) {
            (item.id == notaId) ? data.items.splice(data.items.indexOf(item), 1) : null;
        });

        if (data.items.length === 3) {
            data.items.pop();
        } else if (data.items.length < 2) {
            //nodoAdemas.remove();
            nodoAdemas.parentNode.removeChild(nodoAdemas);
            return false;
        }

        let html = `<div class="techo"> ADEMÁS </div><div>`;
        //<!-- pueden venir hasta 2 articles-->
        for (let nota of data.items) {
            let imageHtml = (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src && nota.imagenes[0].src != "")
                ? `<a class="figure" href="/${nota.url}">       
                                <img src="${BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "82")
                }"/>                   
                              </a>`
                : `<a class="figure"><img src=""/></a>`;

            html += `<article title="" class="nota foto floatFix">
                ${imageHtml}
                <h2>
                    <a href="/${nota.url}">
                        ${nota.titulo}
                    </a>
                </h2>
                </article>`;
        }

        html += `</div>`;
        nodoAdemas.innerHTML = html;
    } else {
        if (nodoAdemas !== null && nodoAdemas !== undefined) {
            nodoAdemas.remove();
        }
        
    }

}

export const notasAdemas = () => {
    if (document.querySelector('div[data-tagPrioridad]')) {
        const cantNotas = 3;
        const fechaHoy = 1;
        let tagId = document.querySelector('div[data-tagPrioridad]').getAttribute('data-tagPrioridad');
        if (tagId == "" || tagId == null)
            return;
    
        let url = urlAcuTema + tagId + "?&c=" + cantNotas + "&s=" + sitioId + "&h=" + fechaHoy;
  
        get(url)
            .then(rs => JSON.parse(rs))
            .then(renderNotasAdemas); 
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/nota/notasAdicionales.js